import React from 'react';
import PercentageBox from '../../../shared/components/PercentageBox';
import { percentageIncrease } from '../../../shared/lib/numberUtils';

const getPercentage = (values) => {
  if (values.length < 60) return null;

  const first30 = values.slice(0, 30);
  const last30 = values.slice(values.length - 30);
  const first30Sum = first30.reduce((sum, value) => sum + value, 0);
  const last30Sum = last30.reduce((sum, value) => sum + value, 0);

  return percentageIncrease(first30Sum, last30Sum);
};

const TrafficWhenStartedCard = ({ site }) => {
  const { bots, human } = site.lifetimeCounts;
  const status = site?.status || null;
  const totalLifetimeTraffic = human.reduce((sum, value) => sum + value, 0) + bots.reduce((sum, value) => sum + value, 0);
  const waitingForTraffic = status === 'red';
  const hasNoTrafficData = totalLifetimeTraffic === 0;
  const analysingTraffic = !waitingForTraffic && !hasNoTrafficData && human.length === 1 && bots.length === 1;
  const humanPercentage = getPercentage(human);
  const botPercentage = getPercentage(bots);

  return (
    <div className="traffic-when-started gradient">
      <div className="traffic-graph__header">
        <div className="chart-title">Traffic Change Since Beginning</div>
      </div>

      {waitingForTraffic || hasNoTrafficData || analysingTraffic ? (
        <p className="empty-state margin-none">
          {waitingForTraffic
            ? 'Waiting for traffic...'
            : hasNoTrafficData
              ? 'No traffic data available yet.'
              : 'Not enough traffic history yet.'}
        </p>
      ) : (
        <div className="traffic-grid">
          <div className="overview-metric">
            <p className="overview-metric__label">Humans</p>
            <PercentageBox percentage={humanPercentage} red={humanPercentage < 0} />
          </div>

          <div className="overview-metric">
            <p className="overview-metric__label">Bots</p>
            <PercentageBox percentage={botPercentage} bot={true} />
          </div>
        </div>
      )}

      <p className="footnote">
        This graph compares the first 30 days of traffic with the latest 30 days. A lower bot trend means click fraud is decreasing over time.
      </p>
    </div>
  );
};

export default TrafficWhenStartedCard;
